import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "DeliveryTruck"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.44 12.4575L20.19 7.2075C20.0726 6.93037 19.801 6.75025 19.5 6.75H17.25V5.25C17.25 4.83579 16.9142 4.5 16.5 4.5H2.25C1.83579 4.5 1.5 4.83579 1.5 5.25V18C1.5 18.4142 1.83579 18.75 2.25 18.75H3.855C4.21005 20.0565 5.39614 20.9632 6.75 20.9632C8.10386 20.9632 9.28995 20.0565 9.645 18.75H14.355C14.71 20.0565 15.8961 20.9632 17.25 20.9632C18.6039 20.9632 19.79 20.0565 20.145 18.75H21.75C22.1642 18.75 22.5 18.4142 22.5 18V12.75C22.4998 12.6495 22.4794 12.55 22.44 12.4575ZM17.25 8.25H19.005L20.61 12H17.25V8.25ZM6.75 19.5C5.92157 19.5 5.25 18.8284 5.25 18C5.25 17.1716 5.92157 16.5 6.75 16.5C7.57843 16.5 8.25 17.1716 8.25 18C8.25 18.8284 7.57843 19.5 6.75 19.5ZM14.355 17.25H9.645C9.28995 15.9435 8.10386 15.0367 6.75 15.0367C5.39614 15.0367 4.21005 15.9435 3.855 17.25H3V6H15.75V15.42C15.0602 15.8203 14.5583 16.4788 14.355 17.25ZM17.25 19.5C16.4216 19.5 15.75 18.8284 15.75 18C15.75 17.1716 16.4216 16.5 17.25 16.5C18.0784 16.5 18.75 17.1716 18.75 18C18.75 18.8284 18.0784 19.5 17.25 19.5ZM21 17.25H20.145C19.8039 15.9289 18.6144 15.0044 17.25 15V13.5H21V17.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/DeliveryTruck.vue"]]);
